import * as React from 'react';
import { CARD_CLASS } from '../../constants';
import { ICardDateTimeIndicatorProps } from './types';
import { Icon, Tooltip } from 'kui';
import './_CardDateTimeIndicator.scss';

export function CardDateTimeIndicator({
    className,
    icon,
    isAction,
    text,
    tooltip,
    modifier
}: ICardDateTimeIndicatorProps) {
    const cardDateIndicator = CARD_CLASS + '__date-value';
    const cardDateText = CARD_CLASS + '__date-text';

    return (
        <Tooltip
            isNoEvents
            isNoWrap
            value={tooltip}
        >
            <span
                className={`
                    ${className || ''}
                    ${cardDateIndicator}
                    ${modifier ? cardDateIndicator + '--' + modifier : ''}
                    ${isAction ? cardDateIndicator + '--action' : ''}
                `}
            >
                {
                    icon &&
                    <Icon xlink={icon}/>
                }
                <span className={cardDateText}>{text}</span>
            </span>
        </Tooltip>
    );
}
